<div [class.container]="isVerticalLayout$ | async" class="toolbar w-full px-gutter flex items-center">
  <button (click)="openSidenav()" [class.hidden]="!mobileQuery" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>

  <a *ngIf="isVerticalLayout$ | async" [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 flex items-center">
    <img alt="Logo" class="w-8 select-none" [src]="'img/demo/logo.svg' | assetUrl" />
    <h1 [class.hidden]="!mobileQuery" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">Belender</h1>
  </a>

  <mat-menu #addNewMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">

    <a mat-menu-item [routerLink]="['/ui/forms/form-wizard']">
      <mat-icon svgIcon="mat:assignment_turned_in"></mat-icon>
      <span>{{'request' | translate:'toolbar'}}</span>
    </a>

  </mat-menu>

  <span class="flex-1"></span>

  <div class="px-1">
    <vex-toolbar-notifications></vex-toolbar-notifications>
  </div>

  <div class=" flex items-center">
    
    <div  class="px-1">
      <vex-toolbar-user></vex-toolbar-user>
    </div>

  </div>
</div>

<vex-navigation *ngIf="(isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async"
  [class.hidden]="mobileQuery"></vex-navigation>